import { render, staticRenderFns } from "./svgTag.vue?vue&type=template&id=0e072f07&scoped=true&"
import script from "./svgTag.vue?vue&type=script&lang=js&"
export * from "./svgTag.vue?vue&type=script&lang=js&"
import style0 from "./svgTag.vue?vue&type=style&index=0&id=0e072f07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e072f07",
  null
  
)

export default component.exports